import { render } from "./GameGift.vue?vue&type=template&id=28b7deab&scoped=true"
import script from "./GameGift.vue?vue&type=script&lang=js"
export * from "./GameGift.vue?vue&type=script&lang=js"

import "./GameGift.vue?vue&type=style&index=0&id=28b7deab&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b7deab"]])

export default __exports__